import React from 'react'
import useAxios from '@use-hooks/axios'
import { CollectionType } from '../types'
import { Collection } from './Collections/Collection'
import { ErrorMessage } from './ErrorMessage'

export const RangeBlocks: React.FC = () => {
  const { error, loading, response } = useAxios({
    url: `/api/getcollections`,
    method: 'GET',
    trigger: 'true',
  })

  if (loading) return null
  if (error) return <ErrorMessage message={error.message} />

  let collections: CollectionType[] = []
  if (response && response.data) {
    collections = JSON.parse(response.data)
  }

  return (
    <>
      {collections.map(collection => (
        <Collection key={collection.title} collection={collection} />
      ))}
    </>
  )
}
